<app-dialog-base titleTranslationKey="file-upload.dialog.title">
  <ng-container content>
    <div class="drag-and-drop-container" appDragAndDrop (fileDropped)="uploadFile($event)">
      <app-drag-and-drop-info></app-drag-and-drop-info>
    </div>
  </ng-container>

  <ng-container actions>
    <div class="buttons">
      <div class="choose-file-button">
        <input hidden type="file" #fileInput [attr.multiple]="multiple ? 'multiple' : null" (change)="uploadFileFromEvent($event)" />
        <button mat-flat-button color="primary" (click)="fileInput.click()">{{ 'file-upload.dialog.action' | translate }}</button>
      </div>

      <div class="choose-folder-button">
        <button mat-flat-button color="primary" (click)="openDirectoryPicker()">
          {{ 'file-upload.dialog.folder-action' | translate }}
        </button>
      </div>
    </div>
  </ng-container>
</app-dialog-base>
